import dynamic from "next/dynamic";
const Layout = dynamic(() => import("../hoc/staticLayout"), {
  loading: () => <></>,
  ssr: true,
});
const StaffContent = dynamic(() => import("../components/static/staff"), {
  loading: () => <></>,
  ssr: true,
});
import { withRouter } from "next/router";
import {
  fetchFaculties,
  fetchStaff,
  getFacultiesData,
  getStaffData,
} from "../api/faculty";

function Staff(props) {
  const meta = {
    title: "World Class Staff | BAYAN AFFILIATED STAFF | Bayan",
    description: "BAYAN AFFILIATED STAFF HAIL FROM PREMIER INSTITUTIONS",
    route: "faculty",
  };
  return (
    <>
      <Layout theme={props.theme} meta={meta}>
        <StaffContent routingPath={props.routingPath} staff={props.staffData} />
      </Layout>
    </>
  );
}

export async function getServerSideProps(context) {
  const staffData = await getStaffData();
  const routingPath = context.req.headers.referer;
  return { props: { staffData: staffData, routingPath: routingPath || null } };
}

export default withRouter(Staff);
